<template>
    <!-- 发布测试 -->
    <el-dialog
        title="发布测试详情"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form :model="ruleForm"  :rules="rules" ref="formName"  >
        <el-form-item label="接收测题年级:" prop="gradeName" label-width="100px" >
             <el-select filterable v-model="ruleForm.gradeName"  @change="gradeClick" placeholder="请选择活动区域">
                <el-option :label="item.name" :value="item.id" v-for="item in schoolList" :key="item.value"  ></el-option>
             </el-select>
         </el-form-item>
         <el-form-item label="班级:" prop="className" label-width="100px">
             <el-select filterable v-model="ruleForm.className"  @change="classClick"  placeholder="请选择活动区域">
                 <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.value" ></el-option>
             </el-select>
         </el-form-item>
        <el-form-item label="名称:" prop="examName" label-width="100px">
              <el-input  v-model="ruleForm.examName"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="题目总数:" prop="questionCount" label-width="100px">
              <el-input  v-model="ruleForm.questionCount"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="作业类型:"  label-width="100px">
            <el-radio-group v-model="ruleForm.type">
                <el-radio label="0">单选</el-radio>
                <el-radio label="1">多选</el-radio>
                <el-radio label="2">判断题</el-radio>
         </el-radio-group>
        </el-form-item>
               <div class="buttom-box">
                    <el-button type="primary" @click="submitForm('formName')">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { gradeList,findClassList ,school,FindSchoolexamResult,classRoomPublishTest} from '@/assets/api/renyuan';

// import { studentRfidAdd} from '@/assets/api/schoollog' 
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    // props: ['Deviceidobj'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            ruleForm:{
                examName:'',
                questionCount:'',
                className:'',
                gradeName:'',
                type:'0'
            },
            cardid:"",
            schoolList:[], //学校列表
            gradeDataList: [],//年级列表
            classList: [],//班级列表
            schoolId:'',
            gradeListId:'',
            UserschoolId:'',
            rules: {
                gradeName: [
                    { required: true, message: '请选择年级', trigger: 'change' }
                ],
                questionCount: [
                    { required: true, message: '请选择题目总数', trigger: 'change' }
                ],
                examName: [
                    { required: true, message: '请选择名称', trigger: 'change' }
                ],
                className: [
                    { required: true, message: '请选择班级', trigger: 'change' }
                ],
                }
            }

    },
    created(){
       
    },
    mounted(){
       
        this.FabuCeshi()
    },
    methods:{
        handleClose() {
            this.$emit('FabuShow')
      },
    //   班级
      classClick () {
            let params = {
                page: '1',
                pageSize: '999',
            }
            findClassList(params,this.ruleForm.gradeName).then((res)=> {
                console.log(res,'班级列表');
                this.classList = res.data.data;
            }).catch((err)=> {
                console.log(err);
            })
        },
    // // 年级
       gradeClick () {
        console.log(1);
            let params = {
                page: '1',
                pageSize: '999',
            }
            gradeList(params,this.UserschoolId).then((res)=> {
                this.schoolList = res.data.data;
            console.log(this.ruleForm.gradeName,111);

                this.classClick()
            }).catch((err)=> {
                console.log(err);
            })
        },
    // // 学校
        // schoolPost () {
        //     let params = {
        //         page: '1',
        //         pageSize: '10',
        //         schoolName: '',
        //         userId:'f91783af-6f7a-4d1e-b952-71c35cbc232f',
        //     }
        //     school(params).then((res)=> {
        //         console.log(res,'学校列表');
        //         // this.schoolList = res.data.data.list

        //     }).catch((err)=> {
        //         console.log(err);
        //     })
        // },
    FabuCeshi(){
        let userId = JSON.parse(localStorage.getItem('user')).id
        FindSchoolexamResult(userId).then((res)=> {
            console.log(res,111);
            this.UserschoolId = res.data.data.schoolId
            this.gradeClick()

        }).catch((err)=> {
            console.log(err,222);
        })
    },
    //  校验
      submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid){
                    console.log(valid);
                    this.AddCeshi()
                }else{
                    console.log(valid);
                }
            });
        },

    AddCeshi(){
        const params = {
                classId:this.ruleForm.className,
                examName:this.ruleForm.examName,
                questionCount:this.ruleForm.questionCount,
                // type:this.ruleForm.type == '单选题'? '0':'1'
                type:this.ruleForm.type 
            }
    
        classRoomPublishTest(params).then((res)=> {
                // console.log(res,'成功');
                this.handleClose()
        }).catch((err) => {
            console.log(err,'失败');
        })
      }

    }
    }




</script>
<style  scoped lang="scss">
    :deep() {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        margin-left: 180px;

    }
    
    .el-form-item--small{
        width: 70% !important;
    }
    .el-select--small .el-select__wrapper {
        height: 35px;
    }
    }
</style>